<template>
  <div :class="{ 'form-fullScreen': isEdit }">
    <div v-show="!dialogFormVisible">
      <!-- <div class="filter-container">
        <div class="filter-box">
          <el-button
            v-permission="{pkey:`${permissionName}_ADD_MARKET_FEE`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
        </div>
      </div> -->
      <TableList
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :page="listQuery.page"
        :size="listQuery.size"
        :showSelection="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :isShowPagination="false"
        :tableName="TableName"
        :permissionName="permissionName"
        :showSummary="true"
        :canCommand="marketFeeCanCommand"
        @command-change="handleCommand"
      >
       <template v-slot:operation-action="scope">
          <el-link
            v-if="scope.row.editable"
            v-permission="{ pkey: `${permissionName}_EDIT_MARKET_FEE` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            {{ t("table.edit") }}
          </el-link>
        </template>
      </TableList>
    </div>
    <template v-if="dialogFormVisible">
      <FormComponent
        v-if="!activeId"
        :id="activeId"
        :initFormData="initFormData"
        :fromFieldData="fromFieldData"
        :dialogFormVisible="dialogFormVisible"
        :api="addPathApi"
        method="PUT"
        :businessDetail="businessDetail"
        :handleResolveTempData="handleResolveTempData"
        @update:visibel="dialogFormVisible = false;isEdit = false"
        @submit="handleSubmit(formData);isEdit = false"
      />
      <FormComponent
        v-else
        :id="activeId"
        :initFormData="initEditFromData"
        :fromFieldData="editFromData"
        :dialogFormVisible="dialogFormVisible"
        :api="editPathPai"
        :businessDetail="businessDetail"
        @update:visibel="dialogFormVisible = false;isEdit = false"
        @submit="handleSubmit(formData);isEdit = false"
      />
    </template>

  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById } from '@/apis/Dictionary'
import { marketFeeList } from '@/apis/Business'
import { getDropdownByType } from '@/apis/tool'
import { getPageList as getUrlList } from '@/apis/Form'

import { PaymentCycleModel } from '@/model/Index'

import FormComponent from './FormData.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { editFromData } from './EditFieldFrom'
import { TableField } from './FieldTable'
import { pageVo } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Paymentcycle',
  components: {
    FormComponent,
    TableList
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    marketFeeCanCommand: {
      type: Boolean,
      required: false,
      default: true
    },
    businessDetail: { type: Object }
  },
  setup(props) {
    const { t } = useI18n()
    const dataMap = reactive({
      businessDetail: props.businessDetail,
      TableName: TableName.TABLE_MARKET_FEE,
      permissionName: permissionName.BUSINESS_LIST,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      editFromData: cloneDeep(editFromData),
      initEditFromData: cloneDeep(editFromData),
      columnAllData: TableField,
      addPathApi: `business/${props.id}/actions/marketFee`,
      editPathPai: 'businessMarketFee',
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      isEdit: false,

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            if (['正式订单', '完成'].includes(dataMap.businessDetail?.status)) {
              ElMessage.closeAll()
              return ElMessage.error(`该业务已${dataMap.businessDetail?.status}，不能申请市场费！`)
            }
            dataMap.handleCreate()
            dataMap.isEdit = true
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        if (!props.id) {
          return
        }
        dataMap.listLoading = true
        marketFeeList(props.id).then((res: any) => {
          dataMap.list = res || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.editFromData = cloneDeep(dataMap.initEditFromData)

        getDetailById(dataMap.editPathPai, row.id).then((res: any) => {
          dataMap.editFromData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey]
              switch (field.fieldKey) {
                case 'customerCompanyContactId': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                  const temp = field.option.find((kk: any) => kk.id === field.value)
                  k.formList.forEach((formItem: any) => {
                    if (formItem.fieldKey === 'account') {
                      formItem.option = temp?.accounts
                    }
                  })
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
          dataMap.isEdit = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger',
            type: 'warning'
          }
        )
          .then(() => {
            deleteById(dataMap.editPathPai, row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleResolveTempData(tempModel: any) {
        console.log(tempModel, 'tempModel')
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })
    watch(() => props.id, () => {
      dataMap.getList()
      dataMap.businessDetail = { ...props.businessDetail, account: props.businessDetail || {}}
    })
    onMounted(() => {
      dataMap.loadTableSelectOption()
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">

</style>
